// Nearpeer Dev Console is the development inspection surface.
// Keep Redux enhancers explicit and lightweight.

module.exports = [];
